<template>
  <span class="icon-Btn">
    <svg
      id="ic_group_add_w"
      xmlns="http://www.w3.org/2000/svg"
      width="13.115"
      height="13.115"
      viewBox="0 0 13.115 13.115"
    >
      <path
        id="Path_1485"
        data-name="Path 1485"
        d="M0,0H13.115V13.115H0Z"
        fill="none"
      />
      <path
        id="Path_1486"
        data-name="Path 1486"
        d="M5.522,8.451H3.451V6.38H2.071V8.451H0v1.38H2.071V11.9h1.38V9.832H5.522Zm3.451.69A2.071,2.071,0,1,0,6.9,7.071,2.062,2.062,0,0,0,8.973,9.141Zm0,1.38c-1.38,0-4.141.69-4.141,2.071v1.38h8.283v-1.38C13.115,11.212,10.354,10.522,8.973,10.522Z"
        transform="translate(0 -3.026)"
        fill="#fff"
      />
    </svg>
  </span>
</template>
<script>
export default {
  name: "createAdIcon",
};
</script>
